exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".toast {\n  background-color: #efefef;\n  border-radius: 10px;\n  box-shadow: 1px 1px 2px 0 rgba(0, 0, 0, 0.3);\n  bottom: 65px;\n  cursor: pointer;\n  color: #8427cc;\n  position: fixed;\n  transition: transform 0.3s ease-in-out;\n  -webkit-transition: transform 0.3s ease-in-out;\n  user-select: none; }\n\n.toast.right {\n  right: -20px;\n  transform: translate3d(100%, 0, 0);\n  -webkit-transform: translate3d(100%, 0, 0); }\n\n.toast.left {\n  transition: left 0.3s ease-in-out;\n  left: -225px; }\n\n.toast.shown {\n  user-select: auto; }\n  .toast.shown.right {\n    transform: translate3d(0, 0, 0);\n    -webkit-transform: translate3d(0, 0, 0); }\n  .toast.shown.left {\n    left: -5px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/components/ToastNotification.scss
// module id = 724
// module chunks = 0